module.exports = __webpack_public_path__ + "img/pink_wave@2x.f1e5efe9.png";